module.exports = __webpack_public_path__ + "static/fine_clothes-e35acf00d6bbf6f015fc842301308b3d.jpg";